import ComponentWithSocket from '../../../lib/component';
import { Component } from 'vue-property-decorator';

@Component
export default class SlidesList extends ComponentWithSocket {
    public data: {
        slides: any[];
    } = {
        slides: []
    };

    constructor() {
        super();
    }

    mounted() {
        this.getSlides();
    }

    async getSlides() {
        let that = this;

        await fetch(`${process.env.API2_URL}/slide`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                that.data.slides = data.data;
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    async removeSlide(id: number) {
        await fetch(`${process.env.API2_URL}/slide/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.getSlides();
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/slides/list/index.ts